import { useCallback } from "react";
import StandaloneSurveyPageLayout from "components/v3/layouts/StandaloneSurveyPageLayout";
import PrecisionGuidanceSurvey from "../../sharedComponents/surveys/PrecisionGuidanceSurvey";
import { trackSurveyAbandonAttempted } from "analytics";

const PrecisionGuidanceSurveyPage = (): React.ReactElement => {
  const handleExitClick = useCallback(() => {
    trackSurveyAbandonAttempted({
      surveyId: "precision-guidance-survey",
      workflow: "precision_guidance_survey",
      action: "opened_exit_modal"
    });
  }, []);

  const handleExitModalClose = useCallback(() => {
    trackSurveyAbandonAttempted({
      surveyId: "precision-guidance-survey",
      workflow: "precision_guidance_survey",
      action: "cancelled_exit"
    });
  }, []);

  return (
    <StandaloneSurveyPageLayout
      maxWidth={900}
      onExitClick={handleExitClick}
      onExitModalClose={handleExitModalClose}
      pageTitle="Precision guidance survey"
    >
      <PrecisionGuidanceSurvey />
    </StandaloneSurveyPageLayout>
  );
};

export default PrecisionGuidanceSurveyPage;
